export const FDE_PATHS: Record<string, { path: string; title: string }> = {
  overview: { path: 'overview', title: 'FDE · 总览统计' },
  myprojects: { path: 'my-projects', title: 'FDE · 我的项目' },
  mycustomers: { path: 'my-customers', title: 'FDE · 我的客户' },
  desk: { path: 'my', title: 'FDE · 我的' },
  project: { path: 'projects', title: 'FDE · 项目工作空间' },
  impl: { path: 'implementation', title: 'FDE · 实施交付' },
  implcfg: { path: 'implementation-config', title: 'FDE · 实施配置' },
  migration: { path: 'data-migration', title: 'FDE · 数据迁移' },
  manager: { path: 'management', title: 'FDE · 管理者' },
  blueprint: { path: 'blueprint', title: 'FDE · 全过程蓝图' },
  matchpoc: { path: 'matching-validation-payments', title: 'FDE · 匹配·验证·回款' },
  planeval: { path: 'implementation-metrics', title: 'FDE · 落地·指标·待确认' },
  career: { path: 'career', title: 'FDE · 职业升级路线' }
}
